/* Optimizer */
var activityEvents = ["mousedown", "mousemove", "keydown", "scroll", "touchstart", "click", "keypress", "touchmove"];
activityEvents.forEach(function (a) {
  window.addEventListener(a, functionCustomJS, !1)
});
let flag = !1;

function functionCustomJS() {
  if (!1 == flag) {
    flag = !0;
    var b = !1;

    function a() {
      setTimeout(function () {
        if (!b) {
          b = !0;
          var d = document.getElementsByTagName("script");
          for (let a = 0; a < d.length; a++) null !== d[a].getAttribute("data-src-content") && (d[a].setAttribute("src", d[a].getAttribute("data-src-content")), delete d[a].dataset.srcContent);
          var e = document.getElementsByTagName("link");
          for (let c = 0; c < e.length; c++) null !== e[c].getAttribute("data-href-content") && (e[c].setAttribute("href", e[c].getAttribute("data-href-content")), delete e[c].dataset.hrefContent);
          setTimeout(function () {
            document.dispatchEvent(new CustomEvent("StartAsyncLoading")), document.dispatchEvent(new CustomEvent("StartKernelLoading"))
          }, 400)
        }
      }, 3e3)
    }

    function c() {
      if (!b) {
        b = !0;
        var d = document.getElementsByTagName("script");
        for (let a = 0; a < d.length; a++) null !== d[a].getAttribute("data-src-content") && (d[a].setAttribute("src", d[a].getAttribute("data-src-content")), delete d[a].dataset.srcContent);
        var e = document.getElementsByTagName("link");
        for (let c = 0; c < e.length; c++) null !== e[c].getAttribute("data-href-content") && (e[c].setAttribute("href", e[c].getAttribute("data-href-content")), delete e[c].dataset.hrefContent);
        setTimeout(function () {
          document.dispatchEvent(new CustomEvent("StartAsyncLoading")), document.dispatchEvent(new CustomEvent("StartKernelLoading"))
        }, 400)
      }
    } ["mousedown", "mousemove", "keydown", "scroll", "touchstart", "click", "keypress", "touchmove"].forEach(function (a) {
      window.addEventListener(a, c, !1)
    }),
    document.addEventListener("load", a, !1),
    document.addEventListener("onload", a, !1), null != window.addEventListener ? window.addEventListener("load", a, !1) : null != window.attachEvent ? window.attachEvent("onload", a) : window.onload = a
  }
}